import React, { useMemo } from 'react'
import ModalPopup from 'britive-design-system/core/components/modal-popup'
import Table from 'britive-design-system/core/components/table'

const EnvironmentList = ({
  onClose,
  environmentList = [],
  selectedApplicationRoot = {},
}) => {
  const selectedApp =
    selectedApplicationRoot?.rootEnvironmentGroup?.environments || []

  const referenceMap = useMemo(() => {
    return new Map(selectedApp.map(item => [String(item.id), item.name]))
  }, [selectedApp])

  const columns = [
    {
      headerName: 'Environment Name',
      renderColumn: row => {
        const name = referenceMap.get(String(row.value))
        return <div className="table-cell">{name || 'N/A'}</div>
      },
    },
    {
      headerName: 'Environment Id',
      renderColumn: row => (
        <div className="table-cell-autocomplete">{row?.value}</div>
      ),
    },
  ]

  return (
    <ModalPopup
      width={500}
      title="Environments"
      buttons={[
        {
          text: 'Close',
          variant: 'secondary',
          onClick: onClose,
          size: 'large',
        },
      ]}
      onCancel={onClose}
    >
      <Table columns={columns} rows={environmentList} />
    </ModalPopup>
  )
}

export default EnvironmentList
